// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./view_transitions"

// Clear Turbo cache after each visit so back/forward always fetches fresh HTML.
// Prevents showing cached "Sign in to like" when user is signed in (or vice versa).
document.addEventListener("turbo:load", () => {
  if (window.Turbo?.cache?.clear) {
    window.Turbo.cache.clear()
  }
})
